import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["blockOnChange", "children"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
/**
 * This component blocks render unless any non-children props change via shallow comparison.
 *
 * Alternatively if `blockOnChange` is set, render will only be blocked when another non-children prop changes.
 * For example, if you know you do not want to re-render when a certain prop changes (use with care).
 */

var RenderBlocker = /*#__PURE__*/function (_Component) {
  _inherits(RenderBlocker, _Component);

  var _super = _createSuper(RenderBlocker);

  function RenderBlocker() {
    _classCallCheck(this, RenderBlocker);

    return _super.apply(this, arguments);
  }

  _createClass(RenderBlocker, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(prevProps) {
      var _this$props = this.props,
          blockOnChange = _this$props.blockOnChange,
          children = _this$props.children,
          props = _objectWithoutProperties(_this$props, _excluded);

      var propsChanged = Object.keys(props).some(function (propName) {
        return props[propName] !== prevProps[propName];
      });
      return this.props.blockOnChange ? !propsChanged : propsChanged;
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return RenderBlocker;
}(Component);

_defineProperty(RenderBlocker, "defaultProps", {
  blockOnChange: false
});

export { RenderBlocker as default };